import type { Account, IAccount } from './accounts/account';

export interface IOrganization {
	accounts: IAccount[];
	id: string;
	name: string;
}

export class Organization implements IOrganization {
	public accounts: Account[];
	public id: string;
	public name: string;
	public constructor({ accounts, id, name }: IOrganization) {
		this.accounts = accounts;
		this.id = id;
		this.name = name;
	}
}
